import React from 'react';
import { Eyebrow } from './Eyebrow';
import { Heading } from './Heading';
import { Subhead } from './Subhead';
import { Body } from './Body';
import { formatText } from '../../utils';
import styled from 'styled-components';
import { spacer32, spacer16, spacer8, spacer24, } from '@spotify-internal/encore-web';
export const StyledHeader = styled.header `
  /* SINCE HEADING IS CURRENTLY REQUIRED
    EYEBROW, NEEDS ONLY THIS SPACING
  */
  & > .eyebrow {
    & + .heading {
      margin-top: ${spacer8};
    }
  }

  & > .heading {
    & + .subhead,
    & + .body,
    & + .cta {
      margin-top: ${spacer16};
    }
  }

  & > .subhead {
    & + .body {
      margin-top: ${spacer16};
    }
  }

  & > .body {
    & + .primary,
    & + .secondary {
      margin-top: ${spacer32};
    }
    & + .tertiary {
      margin-top: ${spacer24};
    }
  }
`;
export const SectionHeader = ({ eyebrow, heading, subhead, cta, ctaVariation = 'primary', className, body, }) => {
    return (React.createElement(StyledHeader, { className: className },
        eyebrow && React.createElement(Eyebrow, null, eyebrow),
        heading && React.createElement(Heading, null, heading),
        subhead && React.createElement(Subhead, null, subhead),
        body && React.createElement(Body, { dangerouslySetInnerHTML: { __html: formatText(body) } }),
        cta && React.createElement("div", { className: `cta ${ctaVariation}` }, cta)));
};
